import HttpRequest from '@/libs/api.axios'
import globConfig from '@/config/config';

// const baseUrl = process.env.NODE_ENV === 'development' ? globConfig.apiUrl.dev : globConfig.apiUrl.pro
// const baseUrl2 = process.env.NODE_ENV === 'development' ? globConfig.apiUrl.dev2 : globConfig.apiUrl.pro2
const baseUrl = globConfig.apiUrl.dev;
const baseUrl2 =  globConfig.apiUrl.dev2;
const baseUrl3 =  globConfig.apiUrl.dev3;
const baseUrl4 =  globConfig.apiUrl.dev4;
// const baseUrl = globConfig.apiUrl.pro;
// const baseUrl2 =  globConfig.apiUrl.pro2;
// const baseUrl3 =  globConfig.apiUrl.pro3;
// debugger
const axios = new HttpRequest(baseUrl,baseUrl2,baseUrl3,baseUrl4);
export default axios


// WEBPACK FOOTER //
// ./src/libs/api.request.js